const Camera = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52853 4.43179H16.5262C17.7831 4.43179 18.75 5.34963 18.75 6.54281V14.2526C18.75 15.4458 17.7831 16.3636 16.5262 16.3636H3.47376C2.21685 16.3636 1.25 15.4458 1.25 14.2526V6.54281C1.25 5.34963 2.21685 4.43179 3.47376 4.43179H3.72169C3.90353 3.96619 4.35648 3.63635 4.88647 3.63635H6.36375C6.89374 3.63635 7.34669 3.96619 7.52853 4.43179ZM17.159 7.2159C17.159 7.87488 16.6248 8.40908 15.9658 8.40908C15.3068 8.40908 14.7726 7.87488 14.7726 7.2159C14.7726 6.55693 15.3068 6.02272 15.9658 6.02272C16.6248 6.02272 17.159 6.55693 17.159 7.2159ZM10.0087 14.7727C11.3623 14.7727 12.5225 14.3838 13.296 13.5088C14.0695 12.6338 14.3354 11.4672 14.3596 10.4949C14.3596 9.23105 14.0695 8.06439 13.296 7.28661C12.5225 6.41161 11.459 6.02272 10.0087 6.02272C8.65514 6.02272 7.49492 6.41161 6.72144 7.28661C5.94796 8.06439 5.56122 9.13383 5.56122 10.3977C5.56122 11.6616 5.94796 12.7311 6.72144 13.5088C7.49492 14.3838 8.55846 14.7727 10.0087 14.7727ZM10.0569 7.48106C9.09007 7.48106 8.41327 7.77273 7.92985 8.25884C7.44642 8.74495 7.25305 9.32828 7.25305 10.2033C7.25305 11.0783 7.44642 11.6616 7.92985 12.1477C8.41327 12.6338 9.09007 12.9255 10.0569 12.9255C10.9271 12.9255 11.7006 12.6338 12.184 12.1477C12.6674 11.6616 12.8608 11.0783 12.8608 10.2033C12.8608 9.32828 12.6674 8.74495 12.184 8.25884C11.7006 7.77273 11.0238 7.48106 10.0569 7.48106Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Camera
